import { Component, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { ImportFlowService } from '@services/imports/import-flow.service';
import { CrossF7DeletedDataSource } from '@components/new-table/data-sources/cross-f7-deleted.dataSource';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { TableColumnsSetting } from '@/interfaces/table-setting';
import { CrossF7DeletedSettingsTable } from '@/table-settings/imports/cross-f7-deleted-settings-table';

@Component({
  selector: 'app-practice-deleted',
  templateUrl: './practice-deleted.component.html',
  styleUrls: ['./practice-deleted.component.scss'],
})
export class PracticeDeletedComponent {
  displayedColumns: TableColumnsSetting<any>;
  dataSource = new CrossF7DeletedDataSource(this.importFlowService);

  toastr = inject(ToastrService);
  dialog = inject(MatDialog);

  reloadTrigger$ = new Subject<any>();

  constructor(private importFlowService: ImportFlowService) {
    this.displayedColumns = CrossF7DeletedSettingsTable.getColumnsSetting();
  }
}
